<template>
  <v-row justify="center">
    <v-dialog
      overlay-opacity="0.8"
      overlay-color="primary"
      :value="topUpDialog"
      persistent
      max-width="800px"
      :content-class="
        topUpDialog ? 'elevation-0 d-flex flex-column align-center' : ''
      "
      transition="scroll-y-transition"
    >
      <v-card flat color="transparent" class="d-flex align-center flex-column">
        <div class="text-h3 secondary--text text-center font-weight-bold mb-5">
          Top-Up Your Homify Wallet
        </div>
        <v-card max-width="500px">
          <v-card-text>
            <v-container>
              <div class="d-flex justify-end mt-n4 mr-n2 mb-4">
                <v-btn
                  icon
                  color="secondary"
                  @click="
                    $emit('toggleDialog', false);
                    resetInput();
                  "
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="topupAmount"
                    outlined
                    label="Total Amount (N)"
                    hint="Minimum of 1000 naira"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12">
                  <v-select
                    :disabled="topupAmount < 1000"
                    v-model="selectedPaymentMethod"
                    :items="[paymentOptions[0]]"
                    item-text="name"
                    return-object
                    label="Choose Payment Option"
                    outlined
                  >
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      <div class="d-flex py-2 align-start">
                        <v-icon color="secondary" size="32">
                          {{ data.item.icon }}
                        </v-icon>
                        <div class="ml-3">
                          <div class="mb-1 font-weight-medium">
                            {{ data.item.name }}
                          </div>
                          <div>{{ data.item.description }}</div>
                        </div>
                      </div>
                    </template>
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      <div class="d-flex py-2 align-center">
                        <v-icon color="secondary" size="32">
                          {{ data.item.icon }}
                        </v-icon>
                        <div class="ml-3">
                          <div class="mb-1 font-weight-medium">
                            {{ data.item.name }}
                          </div>
                          <div>{{ data.item.description }}</div>
                        </div>
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="isPaying"
              color="success"
              text
              @click="initiatePayment"
              :disabled="topupAmount <= 1000 || !selectedPaymentMethod"
              >Proceed</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    <hm-paystack
      :isOpen="isPaystackOpen"
      :paystackCallback="paystackCallback"
      :paystackClose="paystackClose"
      :totalAmount="totalAmount"
      reference
      :paymentChannel="
        selectedPaymentMethod ? selectedPaymentMethod.channel : ''
      "
    />
  </v-row>
</template>

<script>
import HmPaystack from "@/components/HmPaystack";
import { mapState } from "vuex";
import { TransactionService } from "@/services/index.js";

export default {
  props: {
    topUpDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HmPaystack,
  },
  data() {
    return {
      isPaying: false,
      isPaystackOpen: false,
      topupAmount: 0,
      totalAmount: 0,
      selectedPaymentMethod: null,
    };
  },
  computed: {
    ...mapState(["paymentOptions"]),
  },
  methods: {
    initiatePayment() {
      if (this.selectedPaymentMethod.payment_method == "paystack") {
        this.initiatePaystackPayment(this.topupAmount);
      }
    },
    initiatePaystackPayment(total) {
      this.isPaying = true;
      this.isPaystackOpen = true;

      this.totalAmount = Number(total);
    },
    resetInput() {
      this.topupAmount = 0;
      this.totalAmount = 0;
      this.selectedPaymentMethod = null;
      this.isPaying = false;
    },
    async paystackCallback(res) {
      this.$store.commit("openSnackbar", res.status);

      try {
        const { reference } = res;

        const { message } = await TransactionService.topUp(reference);
        this.$emit("completeTopup");
        this.$store.commit("openSnackbar", message);
      } catch (error) {
      } finally {
        this.resetInput();
        this.$emit("toggleDialog", false);
        this.isPaystackOpen = false;
      }
    },
    paystackClose() {
      this.isPaystackOpen = false;
      this.resetInput();
    },
  },
};
</script>
